import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { getIdToken, login } from "../lib/auth";

/**
 * Public landing page. The login button kicks off the Cognito OAuth flow.
 * If a session already exists, hop straight to /accounts.
 */
export default function Landing() {
  const navigate = useNavigate();

  useEffect(() => {
    if (getIdToken()) navigate("/accounts", { replace: true });
  }, [navigate]);

  return (
    <section className="landing">
      <h1>Cosmic Cow Capital</h1>
      <p className="tagline">
        Operator console for the CCC strategy & account fabric.
      </p>
      <button
        className="primary"
        onClick={() => {
          void login();
        }}
      >
        Log in
      </button>
    </section>
  );
}
